import * as Yup from 'yup';
import {
    shouldShowCommitteeObject,
    shouldShowFactor,
} from '../../functions/factorObjectVisibility';

export const prescriptionSchema = Yup.object().shape({
    number: Yup.string('Это не строка').required('Номер нужно указывать'),
    responsibleFullName: Yup.string('Это не строка').required('Должностное лицо санитарно-эпидемиологической службы ( Ф.И.О.) должно быть заполнено'),
    // acts: Yup.array()
    //     .min(1, 'Список актов обязателен к заполнению'),
    indicators: Yup.array()
        .min(1, 'Показатели обязательны к заполнению'),
    factorId: Yup.mixed().nullable().test(
        'factor-required',
        'Фактор обязателен для заполнения',
        function (value) {
            if (!shouldShowFactor(this.parent.purpose)) return true;
            return value != null && value !== '';
        },
    ),
    objectId: Yup.mixed().nullable().test(
        'object-required',
        'Объект обязателен для заполнения',
        function (value) {
            if (!shouldShowCommitteeObject(this.parent.purpose, this.parent.factor)) return true;
            return value != null && value !== '';
        },
    ),
});
